/**
 * Painel de KPIs — eSocial (topo da página)
 * GridProfile / NeuroSynx Ltda
 */
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { Loader2, FileText, FileSignature, Send, CheckCircle2, XCircle, Ban } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const KpiCard = ({ label, value, icon: Icon, color, testid }) => (
  <Card className={`border-l-4 ${color.border}`} data-testid={testid}>
    <CardContent className="p-3 flex items-center gap-3">
      <div className={`p-2 rounded-md ${color.bg}`}>
        <Icon className={`h-5 w-5 ${color.text}`} />
      </div>
      <div>
        <p className="text-xs text-slate-500 uppercase tracking-wide">{label}</p>
        <p className="text-2xl font-bold text-slate-800">{value}</p>
      </div>
    </CardContent>
  </Card>
);

const EsocialKpisPanel = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/api/esocial/kpis`, auth());
      setData(r.data);
    } catch (e) { /* */ }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (loading) {
    return (
      <div className="flex justify-center py-6">
        <Loader2 className="h-5 w-5 animate-spin text-slate-400" />
      </div>
    );
  }
  if (!data) return null;
  const s = data.por_status;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-testid="esocial-kpis">
      <KpiCard label="Rascunho"    value={s.rascunho}      icon={FileText}      color={{ border: 'border-slate-400', bg: 'bg-slate-100',   text: 'text-slate-600'   }} testid="kpi-rascunho" />
      <KpiCard label="Assinados"   value={s.assinado}      icon={FileSignature} color={{ border: 'border-blue-400',  bg: 'bg-blue-50',     text: 'text-blue-600'    }} testid="kpi-assinado" />
      <KpiCard label="Transmitidos"value={s.transmitido}   icon={Send}          color={{ border: 'border-amber-400', bg: 'bg-amber-50',    text: 'text-amber-600'   }} testid="kpi-transmitido" />
      <KpiCard label="Aceitos"     value={s.processado_ok} icon={CheckCircle2}  color={{ border: 'border-emerald-400',bg: 'bg-emerald-50', text: 'text-emerald-600' }} testid="kpi-aceitos" />
      <KpiCard label="Rejeitados"  value={s.rejeitado}     icon={XCircle}       color={{ border: 'border-red-400',   bg: 'bg-red-50',      text: 'text-red-600'     }} testid="kpi-rejeitados" />
      <KpiCard label="Cancelados"  value={s.cancelado}     icon={Ban}           color={{ border: 'border-slate-300', bg: 'bg-slate-50',    text: 'text-slate-500'   }} testid="kpi-cancelados" />
    </div>
  );
};

export default EsocialKpisPanel;
